import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo } from "react";
import { PublicTopBarDesktopAccountInfo } from "~/components/Layouts/PublicBoardLayout/PublicTopBarDesktopAccountInfo";
import { PublicTopBarMobileAccountInfo } from "~/components/Layouts/PublicBoardLayout/PublicTopBarMobileAccountInfo";
export const PublicTopBarAccountInfo = /*#__PURE__*/ memo((param)=>{
    let { account } = param;
    const { isAboveMediumScreen } = useBreakpointsContext();
    const isAnonymousAccount = (account === null || account === void 0 ? void 0 : account.type) === "anonymous";
    return isAboveMediumScreen ? /*#__PURE__*/ _jsx(PublicTopBarDesktopAccountInfo, {
        account: account,
        canCreateAccount: isAnonymousAccount
    }) : /*#__PURE__*/ _jsx(PublicTopBarMobileAccountInfo, {
        account: account,
        canCreateAccount: isAnonymousAccount
    });
});
PublicTopBarAccountInfo.displayName = "PublicTopBarAccountInfo";
